<template>
  <div>
    <div class="no-user-events" v-if="loginIssue">
      <h3>Preview could not be loaded</h3>
      <h5>
        Please click below to login with your CMS credential to view the event
      </h5>
      <a @click="redrictToLogin" href="javascript:void(0)">Redirect To Login</a>
    </div>

    <div id="overlay-join-from-cms" class="login-attendee">
      <div class="attendee-img-hld mx-auto" id="userInitials">
        {{ userInitials }}
      </div>
      <div class="attendee-img-hld mx-auto d-none" id="user-profile-img">
        <img :src="userImage" class="imguserthumb" v-on:load="loadImage()" />
      </div>

      <div class="welcome-attendee">
        <span class="welcome">Welcome </span>
        <span class="attendee">{{ userFirstName }}!</span>
      </div>
      <div>
        <v-progress-circular
          size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import jQuery from "jquery";
let $ = jQuery;
import db from "../components/firebaseInit";
import firebase from "firebase";
import "firebase/auth";
import router from "../router";
import store from "../store";
import analytics from "@/components/Analytics";
import APIs from "@/components/APIInit";
import eventsubscribe from "@/components/EventSubscribe";
import jwt_decode from "jwt-decode";
import common from "@/common";

const landingURLOptions = {
  "/lobby": "Lobby",
  "/sessions": "Sessions",
  "/livestage": "LiveStage",
  "/stageview": "StageView",
  "/attendee": "AttendeeList",
  "/exhibitorshall": "ExhibitorsHall",
  "/mymeetings": "MyMeetings",
  "/myprofile": "MyProfile",
};

var self;
export default {
  data: () => ({
    clientId: "",
    result: "",
    client: "",
    EmailURL: "",
    DynamicColor: "",
    arrEvents: [],
    hostExistcnt: 0,
    Loginloaded: true,
    pageBg: null,
    brandlogo: null,
    microsoftlogin: false,
    googlelogin: false,
    linkedinlogin: false,
    AllowRegister: false,
    bodyTextColor: "#fff",
    loginButtonFillColor: "#f00",
    loginButtonTextColor: "#fff",
    EnableEmailOnlyLogin: false,
    userImage: "",
    userInitials: null,
    userFirstName: "",
    loginIssue: false,
  }),

  methods: {
    loadImage() {
      $("#userInitials").hide();
      $("#user-profile-img").removeClass("d-none");
    },
    redrictToLogin() {
      store.commit("ClearState", this);
      self.loginIssue = false;
      location.href =
        "/preview/" + this.$route.params.eid + "/?error=cookie_not_set";
    },
    checkLogin() {
      debugger;
      store.commit("ClearState", this);
      var apiurl = APIs.UserEvent;
      let CookieAccessToken = this.getCookie("AT");
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CookieAccessToken}`,
      };
      store.commit("setLoginType", "Login");
      axios
        .get(apiurl, { headers: headers })
        .then((response) => {
          console.log("response>>>>>>>>", response.data);
          debugger;
          self.userImage = self.getCDNUrl(
            response.data.profile.ProfilePictureURL
          );
          if (response.data.profile != undefined) {
            self.userInitials = common.getInitials(response.data.profile.Name);
          }
          self.userFirstName = response.data.profile.FirstName;
          document.getElementById("overlay-join-from-cms").style.display =
            "flex";
          firebase
            .auth()
            .signInWithCustomToken(response.data.customToken)
            .then(function () {
              var decoded = jwt_decode(CookieAccessToken);
              document.cookie = "token=";
              document.cookie = "token=" + CookieAccessToken + ";";
              store.commit("addToken", CookieAccessToken);
              store.commit("setCurrentLoggedInTime", decoded.exp);
              document.cookie = "staysigned=";
              document.cookie = "userrole=";
              document.cookie = "userid=";
              self.getEventDetails(response.data);
            })
            .catch(function () {
              self.loginIssue = true;
              document.getElementById("overlay-join-from-cms").style.display =
                "none";
            });
        })
        .catch(function (error) {
          console.log(error);
          self.loginIssue = true;
          document.getElementById("overlay-join-from-cms").style.display =
            "none";
        });
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = document.cookie;
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    getEventDetails(data) {
      var userData = data.profile;
      var email = userData.Email;
      var userRoles = userData.UserRoles;
      var isClientAdmin = false;
      var isEventAdmin = false;
      var roles = [];
      if (userRoles != undefined) {
        userRoles.forEach(function (role) {
          if (role.RoleID == 2) {
            isClientAdmin = true;
          } else if (role.RoleID == 3) {
            isEventAdmin = true;
          }
          roles.push(role.RoleID);
        });
      }
      var channelPrefix = "OAUAT";
      this.createLoginCookieForVideo(userData.UserId, channelPrefix);
      store.commit("addUser", {
        id: userData.UserId,
        Email: email,
        name: userData.Name,
        fname: userData.FirstName,
        lname: userData.LastName,
        profilepic: userData.ProfilePictureURL,
        company: userData.Company,
        title: userData.Designation,
        phone: userData.Phone,
        roles: roles,
      });

      let cid = this.$route.params.cid;
      let eid = this.$route.params.eid;
      //self.addAnalytics("Login");
      debugger;
      var result = data.result;
      var events = [];
      var i;
      var j;
      for (i = 0; i < result.length; ++i) {
        for (j = 0; j < result[i].events.length; j++) {
          if (isClientAdmin || isEventAdmin) {
            if (
              result[i].events[j].EventId == eid &&
              result[i].events[j].ClientId == cid
            ) {
              events.push(result[i].events[j]);
            }
          }
        }
      }

      store.commit("setMappedEvent", events);
      store.commit("addEventCount", events.length);

      if (events.length == 0) {
        document.getElementById("dvOtherMsg").innerText = self.$t(
          "login.eventnotpublished"
        );
        $("#Othermsg-modal").modal("show");
        $("#btnLogin").val(self.$t("login.title"));
      } else if (events.length > 1) {
        $("#btnLogin").prop("disabled", true);
        $("#btnLogin").val(self.$t("login.pleasewait"));
        store.commit("setPreviewLogin", true);
        router.push({ name: "EventList" });
      } else {
        $("#btnLogin").prop("disabled", true);
        //self.goToEvent(events);
        self.goToEventModified(events);
      }
    },
    goToEventModified: async function (eventDoc) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var eventData = eventDoc[0];
      this.$store.state.locale =
        eventData.DefaultLanguage === undefined
          ? "English"
          : eventData.DefaultLanguage;
      store.commit("addAttendeeID", obj.user[0].UserId);
      store.commit("addEventID", eventData.EventId);
      store.commit("addEventCollection", eventData.EventCollectionName);
      store.commit("addEventName", eventData.EventFullName);
      store.commit("addEventSdate", eventData.EventStartDate);
      store.commit("addEventEdate", eventData.EventEndDate);
      store.commit("addZone", eventData.TimeZone);
      store.commit("setBrandingJsonUrl", eventData.brandingJsonUrl);
      let clientName = this.$store.state.client[0].name;
      store.commit("addClientID", {
        id: eventData.ClientId,
        name: clientName,
      });
      // this.$store.commit(
      //   "setClientEventBranding",
      //   eventData.isCustomEventBranding
      // );
      var brandingData;
      try {
        brandingData = await self.getBrandingJSONDetails(
          eventData.EventCollectionName +
            "/Branding/CustomStyle/EventCustomCSS.json"
        );
        if (brandingData.data.customClientFont != undefined) {
          store.commit("AddEventFont", {
            FontPath: brandingData.data.customClientFont.FontPath,
            FontFamily: brandingData.data.customClientFont.FontFamily,
          });
        }
      } catch (e) {
        console.log("Error in Branding Json Fetch--", e);
      }

      try {
        brandingData = await self.getBrandingJSONDetails(
          eventData.EventCollectionName + "/Branding/Branding.json"
        );
        if (brandingData.data != undefined) {
          this.item = brandingData.data;
          var bannerDymension = "2048x88"; //"640x88"; // "2048x88";
          var EventBgDymension = "2732x2048";
          var logoDymension = "960x192";
          store.commit("addEventBranding", {
            eventBGImage: self.getCDNUrl(
              brandingData.data.eventBGImage[EventBgDymension]
            ),
            eventLogo: self.getCDNUrl(
              brandingData.data.eventLogo[logoDymension]
            ),
            topBar: brandingData.data.headerColorsHexCode["topBar"],
            headerBar: brandingData.data.headerColorsHexCode["headerBar"],
            fontBar: brandingData.data.headerColorsHexCode["fontBar"],
            sideNavigationAndIconColor:
              brandingData.data.headerColorsHexCode[
                "sideNavigationAndIconColor"
              ],
            banner: self.getCDNUrl(brandingData.data.banner[bannerDymension]),
            mobileBanner: self.getCDNUrl(brandingData.data.banner["750x103"]),
            shareBanner: self.getCDNUrl(
              brandingData.data.banner["1200x628"]
                ? brandingData.data.banner["1200x628"]
                : ""
            ),
            themeName: brandingData.data["appColorHexCodeType"],
          });
          $("#btnLoadMenu").click();
          // this.getMeetingSettings();
          // this.getAdvExpoStatus();
          // this.getDynamicFont();
          let landingURL = "Lobby";
          if (
            eventData.DefaultLandingURL &&
            landingURLOptions[eventData.DefaultLandingURL] &&
            landingURLOptions[eventData.DefaultLandingURL] != ""
          ) {
            landingURL = landingURLOptions[eventData.DefaultLandingURL];
          }
          if (this.$store.state.eventDefaultSessionPage) {
            landingURL =
              landingURLOptions[this.$store.state.eventDefaultSessionPage];
          }

          if (landingURL === "ExhibitorsHall") {
            //this.onExpoSelection();
            store.commit("setAdvExpo", true);
          }
          analytics.AddUserLogin(
            eventData.EventCollectionName,
            eventData.EventFullName,
            location.pathname,
            "click",
            "action",
            obj.loginType,
            obj.user[0].id,
            obj.user[0].fname.trim() + " " + obj.user[0].lname.trim(),
            obj.user[0].Email,
            obj.ClientIP
          );
          if (this.$store.state.staySignedIn)
            this.$store.state.historyLandinURL = landingURL;
          store.commit("setPreviewLogin", true);
          router.push({
            name: landingURL,
            params: {
              sid: eventDoc.id,
              eCol: eventData.EventCollectionName,
              ename: eventData.EventFullName,
              estartdt: eventData.EventStartDate,
              eenddt: eventData.EventEndDate,
              tzone: eventData.TimeZone,
            },
          });
        }
      } catch (e) {
        self.mainLoginButtonLoader = false;
        console.log("Error in Branding Json Fetch--", e);
      }
    },

    goToEvent: async function (eventDoc) {
      console.log("eventDoc======", eventDoc);
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var email = obj.user[0].Email;
      var eventData = eventDoc[0];
      this.$store.state.locale =
        eventData.DefaultLanguage === undefined
          ? "English"
          : eventData.DefaultLanguage;
      //store.commit("addEventID", eventData.id);
      store.commit("addEventID", eventData.EventId);
      store.commit("addEventCollection", eventData.EventCollectionName);
      store.commit("addEventName", eventData.EventFullName);
      store.commit("addEventSdate", eventData.EventStartDate);
      store.commit("addEventEdate", eventData.EventEndDate);
      store.commit("addZone", eventData.TimeZone);
      let clientName = this.$store.state.client[0].name;
      store.commit("addClientID", {
        id: eventData.ClientId,
        name: clientName,
      });

      /*++++++++ Font style EventCustomCSS.json JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
      const storage = firebase.storage();
      const storageRef = storage.ref();
      const objectCSSRef = storageRef.child(
        eventData.EventCollectionName +
          "/Branding/CustomStyle/EventCustomCSS.json"
      );

      objectCSSRef
        .getDownloadURL()
        .then((url) => {
          axios.get(url).then((response) => {
            console.log("Response Data:- " + response.data);

            if (response.data.customClientFont != undefined) {
              store.commit("AddEventFont", {
                FontPath: response.data.customClientFont.FontPath,
                FontFamily: response.data.customClientFont.FontFamily,
              });
            }
          });
        })
        .catch((error) => {
          //alert(error);
          console.log(error);
        });

      await db
        .collection("OA_UAT")
        .doc("UserList")
        .collection("Users")
        .where("Email", "==", email)
        //.where("IsPublished", "==", true)
        //.where("MappedEvents", "array-contains", EventID)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            //
            var AttendeeID = doc.data().UserId;
            store.commit("addAttendeeID", AttendeeID);
            const storage = firebase.storage();
            const storageRef = storage.ref();
            // const entityRef = storage.ref('item/apple.json');
            const objectRef = storageRef.child(
              eventData.EventCollectionName + "/Branding/Branding.json"
            ); // OA_UAT_C1591205467009E1591206650065/Branding/Branding.json"
            objectRef.getDownloadURL().then((url) => {
              axios
                .get(url)
                .then((response) => {
                  this.item = response.data;

                  console.log(response.data);
                  var bannerDymension = "2048x88"; //"640x88"; // "2048x88";
                  var EventBgDymension = "2732x2048";
                  var logoDymension = "960x192";

                  console.log(response.data.banner[bannerDymension]);
                  console.log(response.data.eventBGImage[EventBgDymension]);
                  store.commit("addEventBranding", {
                    eventBGImage: response.data.eventBGImage[EventBgDymension], //data.LoginAssets.bg2732x2048,
                    eventLogo: response.data.eventLogo[logoDymension],
                    topBar: response.data.headerColorsHexCode["topBar"],
                    headerBar: response.data.headerColorsHexCode["headerBar"],
                    fontBar: response.data.headerColorsHexCode["fontBar"],
                    sideNavigationAndIconColor:
                      response.data.headerColorsHexCode[
                        "sideNavigationAndIconColor"
                      ],
                    banner: response.data.banner[bannerDymension],
                    mobileBanner: self.getCDNUrl(
                      response.data.banner["750x103"]
                    ),
                    shareBanner: self.getCDNUrl(
                      response.data.banner["1200x628"]
                        ? response.data.banner["1200x628"]
                        : ""
                    ),
                    themeName: response.data["appColorHexCodeType"],
                  });
                  $("#btnLoadMenu").click();
                  //self.getAttendeeID();
                  //self.getMeetingSettings();
                  //self.getAdvExpoStatus();
                  //self.setBannerRedirect();
                  //self.getDynamicFont();
                  //  this.SubscribeForWebPush();kk
                  let landingURL = "session3";
                  if (
                    eventData.DefaultLandingURL &&
                    landingURLOptions[eventData.DefaultLandingURL] &&
                    landingURLOptions[eventData.DefaultLandingURL] != ""
                  ) {
                    //landingURL = landingURLOptions[eventData.DefaultLandingURL];
                  }

                  if (landingURL === "ExhibitorsHall") {
                    this.onExpoSelection();
                    store.commit("setAdvExpo", true);
                  }
                  analytics.AddUserLogin(
                    eventData.EventCollectionName,
                    eventData.EventFullName,
                    location.pathname,
                    "click",
                    "action",
                    obj.loginType,
                    obj.user[0].id,
                    obj.user[0].fname.trim() + " " + obj.user[0].lname.trim(),
                    obj.user[0].Email,
                    obj.ClientIP
                  );
                  router.push({
                    name: landingURL,
                    params: {
                      sid: eventDoc.id,
                      eCol: eventData.EventCollectionName,
                      ename: eventData.EventFullName,
                      estartdt: eventData.EventStartDate,
                      eenddt: eventData.EventEndDate,
                      tzone: eventData.TimeZone,
                    },
                  });
                })
                .catch((error) => {
                  //alert(error);
                  console.log(error);
                });
            });
          });
        })
        .catch((error) => {
          //alert(error);
          console.log(error);
        });
    },

    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },

    getAttendeeID: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var email = obj.user[0].Email;
      //var EventID = obj.eventid;

      db.collection(obj.eventcollectionname)
        .doc("AttendeeList")
        .collection("Attendees")
        .where("Email", "==", email)
        //.where("MappedEvents", "array-contains", EventID)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            //
            var data = doc.data();
            var AttendeeID = data.AttendeeId;
            store.commit("addAttendeeID", AttendeeID);
          });
        })
        .catch((error) => {
          //alert(error);
          console.log(error);
        });
    },

    getMeetingSettings: function () {
      debugger;
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
      };
      axios
        .post(APIs.MeetingAPIConfig.GetConfig, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((response) => {
          debugger;
          console.log(response);
          var res = response.data;
          var MObj = new Object();
          MObj.Slot = res.data.Slots;
          MObj.StartDate = res.data.StartDate;
          MObj.EndDate = res.data.EndDate;
          MObj.AvailabilityFromTime = res.data.AvailabilityFromTime;
          MObj.AvailabilityToTime = res.data.AvailabilityToTime;
          MObj.ButtonLabel = res.data.ButtonLabel;
          MObj.Duration = res.data.Duration;
          if (res.data.ByTimezone !== undefined) {
            MObj.ByTimezone = res.data.ByTimezone;
          } else {
            MObj.ByTimezone = false;
          }
          if (res.data.Items && res.data.Items.length > 0) {
            MObj.Items = res.data.Items;
          }

          store.commit("addMeetingSettings", MObj);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAdvExpoStatus: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("Settings")
        .collection("Exhibitor")
        .get()
        .then((querySnapshot) => {
          this.SubscribeForWebPush(); //kk
          querySnapshot.forEach((doc) => {
            if (doc.data().EnableEnhancedExpoMode === true) {
              store.commit("setAdvExpo", true);
            } else {
              store.commit("setAdvExpo", false);
            }
          });
        })
        .catch((error) => {
          alert(error);
        });
    },
    onExpoSelection() {
      $("#liexhibitor")
        .find("a:first")
        .addClass("router-link-exact-active router-link-active");
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.eventcollectionname !== undefined) {
        if (obj.eventcollectionname !== "") {
          db.collection(obj.eventcollectionname)
            .doc("Settings")
            .collection("Exhibitor")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                if (doc.data().EnableEnhancedExpoMode === true) {
                  router.push("/exhibitorshall");
                  store.commit("setAdvExpo", true);
                } else {
                  store.commit("setAdvExpo", false);
                  router.push("/exhibitor");
                }
              });
            })
            .catch((error) => {
              alert(error);
            });
        }
      }
    },

    SubscribeForWebPush() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      eventsubscribe.SubscribeUser(
        obj.eventcollectionname,
        obj.user[0].Email,
        obj.user[0].id,
        obj.ShowNotification
      );
    },

    createLoginCookieForVideo: function (UserID, channelPrefix) {
      var cookieExpDate = new Date();
      var minutes = 1440 * 7; //7 days
      cookieExpDate.setTime(cookieExpDate.getTime() + minutes * 60 * 1000);
      var val = channelPrefix + "_" + UserID.toString();
      document.cookie =
        "vuid=" +
        val +
        "; expires=" +
        cookieExpDate +
        "; path=/;domain=.e2m.live;secure=true";
    },
  },
  mounted: function () {
    self = this;
    $("#topmenu").hide();
    $("#leftmenu").hide();
    self.checkLogin();
  },
};
</script>
<style>
#overlay-join-from-cms {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 2;
  cursor: pointer;
}
.login-attendee {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.login-attendee .attendee-img-hld {
  width: 132px;
  height: 132px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 54px;
  text-transform: uppercase;
  border: 1px solid #f2f2f2;
  background-color: #ebeff2;
  color: #6d6f7b;
}
.login-attendee .attendee {
  color: rgb(28, 29, 38);
  font-size: 24px;
  font-weight: 500;
}
.login-attendee .welcome {
  font-size: 24px;
  padding-right: 5px;
}
.no-user-events {
  margin: 0 auto;
  text-align: center;
  margin-top: 100px;
}
.no-user-events h3 {
  font-weight: 700;
  font-size: 30px;
  color: #333;
  margin-bottom: 25px;
}
.no-user-events a {
  display: inline-block;
  padding: 8px 30px;
  background: #00a982;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 5px;
  box-shadow: 0 5px 0 rgba(0, 0, 0, 0.5);
  margin-top: 15px;
}
.no-user-events a:active {
  transform: translateY(5px);
  box-shadow: none;
}
</style>